<template>
	<g>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M32.5 16.3637C32.5 15.2292 32.3961 14.1383 32.2032 13.091H16.8265V19.2801H25.6132C25.2347 21.2801 24.0844 22.9746 22.3553 24.1092V28.1237H27.6317C30.7189 25.3382 32.5 21.2364 32.5 16.3637Z"
			fill="#4285F4"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.8266 31.9999C21.2347 31.9999 24.9304 30.5673 27.6317 28.1237L22.3553 24.1092C20.8933 25.0692 19.0232 25.6363 16.8266 25.6363C12.5742 25.6363 8.97497 22.8218 7.69111 19.04H2.23656V23.1854C4.92302 28.4145 10.4444 31.9999 16.8266 31.9999Z"
			fill="#34A853"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.69111 19.04C7.36458 18.08 7.17904 17.0546 7.17904 16.0001C7.17904 14.9455 7.36457 13.9201 7.6911 12.9601V8.81462H2.23655C1.1308 10.9746 0.5 13.4182 0.5 16.0001C0.5 18.5819 1.13081 21.0254 2.23656 23.1854L7.69111 19.04Z"
			fill="#FBBC05"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.8266 6.36363C19.2236 6.36363 21.3757 7.1709 23.0677 8.75635L27.7505 4.16727C24.923 1.58545 21.2273 0 16.8266 0C10.4444 0 4.92301 3.58553 2.23655 8.81462L7.6911 12.9601C8.97496 9.17825 12.5742 6.36363 16.8266 6.36363Z"
			fill="#EA4335"
		/>
	</g>
</template>
